export function registerSliders(Alpine) {

  Alpine.data('slideAnnouncement', () => ({
    open: true,

    close() {
      this.open = false;

      // Chờ hiệu ứng CSS kết thúc (thường là 300ms-500ms) rồi mới update Swiper
      setTimeout(() => {
        if (window.lucideSwiper) {
          window.lucideSwiper.update();
        }
      }, 420); // Đặt thời gian dài hơn transition một chút
    }
  }));

  // Alpine directive for home top slider with line split animation
  Alpine.directive("hometopslider", (el) => {
    if (el._x_homeTopSwiper) return;
    // Destroy swiper instance if exists
    const animatedRealIndexes = new Set();

    const splitSlideLines = (slide) => {
      if (!slide) return;
      const splitLineEls = Array.from(slide.querySelectorAll(".splitlines"));
      if (!splitLineEls.length) return;

      splitLineEls.forEach((lineEl) => {
        if (lineEl.querySelector("[data-line]")) return;
        text.splitText(lineEl, { lines: { wrap: 'clip' }, words: false, chars: false });
      });
    };

    const animateSlideText = (swiper, attempt = 0) => {
      if (!swiper) return;
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      splitSlideLines(activeSlide);

      const realIndex = Number(swiper.realIndex);
      if (animatedRealIndexes.has(realIndex)) return;

      const titleLines = activeSlide.querySelectorAll("[title] [data-line]");
      const subtitleLines = activeSlide.querySelectorAll("[subtitle] [data-line]");
      const textLines = activeSlide.querySelectorAll("[text] [data-line]");
      const linkEls = activeSlide.querySelectorAll("[link]");

      const hasLineTargets = titleLines.length || subtitleLines.length || textLines.length;
      if (!hasLineTargets) {
        if (attempt < 6) {
          setTimeout(() => {
            animateSlideText(swiper, attempt + 1);
          }, 80);
        }
        return;
      }

      animatedRealIndexes.add(realIndex);

      animate(titleLines, {
        y: ['100%', '0%'],
        delay: stagger(150, { start: 200 }),
      });
      animate(subtitleLines, {
        y: ['100%', '0%'],
        delay: stagger(150, { start: 600 }),
      });
      animate(textLines, {
        y: ['100%', '0%'],
        delay: stagger(150, { start: 600 }),
      });
      if (linkEls.length) {
        animate(linkEls, {
          opacity: [0, 1],
          y: ['100%', '0%'],
          delay: stagger(150, { start: 800 }),
        });
      }
    };

    const updateTheme = (swiper) => {
      // 1. Tìm slide đang active
      const activeSlide = swiper.slides[swiper.activeIndex];

      // 2. Lấy class theme (ví dụ: slide-theme-light hoặc slide-theme-dark)
      const themeClass = Array.from(activeSlide.classList).find(c => c.startsWith('slide-theme-home-'));

      // 3. Cập nhật class này lên thẻ bao ngoài của pagination/navigation
      const controller = document.getElementById('theme-controller');
      if (controller && themeClass) {
        // Xóa các class theme cũ nếu có
        controller.classList.remove('slide-theme-home-light', 'slide-theme-home-dark');
        // Thêm class theme mới
        controller.classList.add(themeClass);
      }
    }

    const swiper = new Swiper(el, {
      loop: true,
      speed: 900,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: el.querySelector(".agi-pagination"),
      },
      navigation: {
        nextEl: el.querySelector(".agi-button-next"),
        prevEl: el.querySelector(".agi-button-prev"),
      },
      scrollbar: {
        el: el.querySelector(".swiper-scrollbar"),
      },
      on: {
        init(swiper) {
          swiper.slides.forEach((slide) => {

            splitSlideLines(slide);
          });

          // Run animation for the first active slide after a short delay to ensure everything is rendered
          setTimeout(() => {
            updateTheme(swiper);
            animateSlideText(swiper);
          }, 500);
        },
        slideChange(swiper) {
          // console.log("Slide changed to index:", swiper.activeIndex);

          // Run animation for the new active slide
          animateSlideText(swiper);
          updateTheme(swiper);

        },
      },
    });
    el._x_homeTopSwiper = swiper;
  });

  // Alpine directive for knowledge slider with pagination
  Alpine.directive("knowledgeslider", (el) => {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 600,
      
      pagination: {
        el: el.querySelector(".knowledge-pagination"),
        type: "bullets",
        clickable: true,
      },
    });
  });

  // Alpine directive for news slider with pagination and navigation
  Alpine.directive("newsslider", (el) => {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 600,
      pagination: {
        el: el.querySelector(".agi-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".agi-button-next"),
        prevEl: el.querySelector(".agi-button-prev"),
      },
    });
  });
  Alpine.directive("postarchiveslider", (el) => {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 24, // Tăng khoảng cách để các slide không dính nhau khi scale
      grabCursor: true,
      watchSlidesProgress: true,
      speed: 1200, // Tốc độ trượt chậm lại một chút để thấy rõ độ mượt

      // Cấu hình nâng cao cho cảm giác mượt
      touchRatio: 1.2,
      resistanceRatio: 0.85, // Tạo cảm giác nặng đô ở hai đầu slider
      freeMode: {
        enabled: true,
        sticky: true, // Vuốt xong sẽ tự nhảy về slide gần nhất
      },
      breakpoints: {
        // Trên màn hình lớn hơn (md)
        769: {
          slidesPerView: 'auto',
          spaceBetween: 24,
        },
        // Trên màn hình desktop (xl)
        1280: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        }
      },
      pagination: {
        el: el.querySelector(".agi-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".agi-button-next"),
        prevEl: el.querySelector(".agi-button-prev"),
      },
      on: {
        init: function () {
          // Kích hoạt slide đầu tiên
          this.slides[this.activeIndex].querySelectorAll('.has-animation').forEach(el => {
            el.classList.add('animate-in');
          });
        },
        slideChangeTransitionStart: function () {
          // Xóa class của các slide cũ để có thể chạy lại khi quay lại
          this.slides.forEach(slide => {
            slide.querySelectorAll('.has-animation').forEach(el => el.classList.remove('animate-in'));
          });
        },
        slideChangeTransitionEnd: function () {
          // Thêm class cho slide hiện tại
          this.slides[this.activeIndex].querySelectorAll('.has-animation').forEach(el => {
            el.classList.add('animate-in');
          });
        }
      }
    });
  });

  Alpine.directive("solutionproductslider", (el) => {
    if (el._x_solutionProductSwiper) return;

    const prevSelector = el.dataset.prev;
    const nextSelector = el.dataset.next;
    const root = el.parentElement;
    const prevEl = prevSelector && root ? root.querySelector(prevSelector) : null;
    const nextEl = nextSelector && root ? root.querySelector(nextSelector) : null;

    const swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      speed: 600,
      grabCursor: false,
      watchOverflow: true,
      autoHeight: false,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });

    el._x_solutionProductSwiper = swiper;
  });

  // 1. Directive cho Swiper ảnh nhỏ (Thumbnails)
Alpine.directive("gallery-thumbs", (el) => {
  const swiper = new Swiper(el, {
    direction: 'horizontal',
    initialSlide: 0,
    speed: 550,
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 12,      // Khoảng cách giữa các ảnh nhỏ
    watchSlidesProgress: true,
    centerInsufficientSlides: false,
    centeredSlides: false,
    watchOverflow: true,
    observer: true,
    observeParents: true,

    breakpoints: {
      769: {
        direction: 'horizontal',
        slidesPerView: 4,
        slidesPerGroup: 1,
        centeredSlides: false,
        centerInsufficientSlides: false,
        spaceBetween: 16,
      },
      1281: {
        direction: 'vertical',
        slidesPerView: 4,
        slidesPerGroup: 1,
        centeredSlides: false,
        centerInsufficientSlides: false,
        spaceBetween: 16,
      }
    },
    on: {
      init(instance) {
        instance.slideTo(0, 0);
      },
    }
  });

  el._x_swiper = swiper;
});

  // 2. Directive cho Swiper ảnh lớn
  Alpine.directive("gallery-main", (el) => {
    // Đợi một nhịp để Thumb Swiper kịp khởi tạo (vì thumb thường nằm trước trong DOM)
    setTimeout(() => {
      // Tìm element chứa thumb swiper (giả sử nằm cùng cụm cha)
      const container = el.closest('.gallery-container');
      const isVisible = (node) => !!(node && (node.offsetWidth || node.offsetHeight || node.getClientRects().length));

      // Tìm tất cả các thumb swiper trong container
      const allThumbs = container.querySelectorAll('[x-gallery-thumbs]');
      const allPrevEls = container.querySelectorAll('[data-gallery-thumbs-prev]');
      const allNextEls = container.querySelectorAll('[data-gallery-thumbs-next]');
      const activePrevEl = Array.from(allPrevEls).find(isVisible) || null;
      const activeNextEl = Array.from(allNextEls).find(isVisible) || null;
      const hasActiveThumbNav = !!(activePrevEl && activeNextEl);

      // Lọc ra cái đang hiển thị (không có display: none)
      const activeThumbEl = Array.from(allThumbs).find(thumb => {
        return isVisible(thumb);
      });

      new Swiper(el, {
        initialSlide: 0,
        spaceBetween: 12,
        navigation: {
          nextEl: hasActiveThumbNav ? activeNextEl : el.querySelector('.swiper-button-next'),
          prevEl: hasActiveThumbNav ? activePrevEl : el.querySelector('.swiper-button-prev'),
        },
        // Kết nối với instance của thumb swiper
        thumbs: {
          swiper: activeThumbEl ? activeThumbEl._x_swiper : (allThumbs[0] ? allThumbs[0]._x_swiper : null),
        },
        on: {
          init(swiper) {
            swiper.slideTo(0, 0);

            if (activeThumbEl && activeThumbEl._x_swiper) {
              activeThumbEl._x_swiper.slideTo(0, 0);
              activeThumbEl._x_swiper.updateSlidesClasses();
            }

            if (hasActiveThumbNav) {
              activePrevEl.disabled = swiper.isBeginning;
              activeNextEl.disabled = swiper.isEnd;
              activePrevEl.classList.toggle('opacity-40', swiper.isBeginning);
              activeNextEl.classList.toggle('opacity-40', swiper.isEnd);
              activePrevEl.classList.toggle('pointer-events-none', swiper.isBeginning);
              activeNextEl.classList.toggle('pointer-events-none', swiper.isEnd);
            }

            // Chạy animation cho ảnh đầu tiên
            const firstImg = swiper.slides[swiper.activeIndex].querySelector('img');
            if (firstImg) {
              animate(firstImg, {
                opacity: [0, 1],
                scale: [1.1, 1],
                filter: ['blur(10px)', 'blur(0px)']
              }, { duration: 0.8 });
            }
          },
          slideChangeTransitionStart(swiper) {
            if (hasActiveThumbNav) {
              activePrevEl.disabled = swiper.isBeginning;
              activeNextEl.disabled = swiper.isEnd;
              activePrevEl.classList.toggle('opacity-40', swiper.isBeginning);
              activeNextEl.classList.toggle('opacity-40', swiper.isEnd);
              activePrevEl.classList.toggle('pointer-events-none', swiper.isBeginning);
              activeNextEl.classList.toggle('pointer-events-none', swiper.isEnd);
            }

            // Animation khi đổi slide: Ảnh mới sẽ scale nhẹ và hiện ra
            const activeSlide = swiper.slides[swiper.activeIndex];
            const img = activeSlide.querySelector('img');
            if (img) {
              animate(img, {
                opacity: [0, 1],
                scale: [1.05, 1],
                y: [10, 0]
              }, { duration: 0.6 });
            }
          }
        }
      });
    }, 0);
  });

  // Environmental slider
  //   Alpine.directive("environmentalslider", (el) => {
  //   const section = el.closest(".environment-section");

  //   console.log("environmentalslider init", {
  //     el,
  //     next: section?.querySelector(".agi-button-next"),
  //     prev: section?.querySelector(".agi-button-prev"),
  //     pagination: section?.querySelector(".agi-pagination"),
  //   });

  //   new Swiper(el, {
  //     slidesPerView: "auto",
  //     spaceBetween: 24,
  //     speed: 700,
  //     grabCursor: true,
  //     watchOverflow: true,
  //     navigation: {
  //       nextEl: section?.querySelector(".agi-button-next"),
  //       prevEl: section?.querySelector(".agi-button-prev"),
  //     },
  //     pagination: {
  //       el: section?.querySelector(".agi-pagination"),
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       768: {
  //         spaceBetween: 20,
  //       },
  //       1280: {
  //         spaceBetween: 24,
  //       },
  //     },
  //   });
  // });

  const setButtonState = (buttonEl, isDisabled) => {
    if (!buttonEl) return;
    buttonEl.style.opacity = isDisabled ? "0.35" : "1";
    buttonEl.style.pointerEvents = isDisabled ? "none" : "auto";
    buttonEl.setAttribute("aria-disabled", isDisabled ? "true" : "false");
    buttonEl.classList.toggle("swiper-button-disabled", isDisabled);

    const nativeBtn =
      buttonEl.tagName === "BUTTON" ? buttonEl : buttonEl.querySelector("button");
    if (nativeBtn) nativeBtn.disabled = isDisabled;
  };

  const setNavState = (swiper, prevBtn, nextBtn) => {
    setButtonState(prevBtn, swiper.isBeginning);
    setButtonState(nextBtn, swiper.isEnd);
  };

  const setCustomPagination = ({
    swiper,
    paginationEl,
    bulletsCount,
    getSlideIndexByBullet,
    getActiveBulletIndex,
    labelPrefix = "Go to step",
    signature,
  }) => {
    if (!paginationEl) return;
    if (bulletsCount <= 1) {
      paginationEl.innerHTML = "";
      paginationEl.dataset.paginationSignature = "";
      return;
    }

    if (paginationEl.dataset.paginationSignature !== signature) {
      paginationEl.innerHTML = "";
      for (let index = 0; index < bulletsCount; index += 1) {
        const bullet = document.createElement("button");
        bullet.type = "button";
        bullet.className = "swiper-pagination-bullet";
        bullet.setAttribute("aria-label", `${labelPrefix} ${index + 1}`);
        bullet.addEventListener("click", () => {
          swiper.slideTo(getSlideIndexByBullet(index));
        });
        paginationEl.appendChild(bullet);
      }
      paginationEl.dataset.paginationSignature = signature;
    }

    const activeBulletIndex = getActiveBulletIndex();
    const bullets = paginationEl.querySelectorAll(".swiper-pagination-bullet");
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle("swiper-pagination-bullet-active", index === activeBulletIndex);
    });
  };

  Alpine.directive("environmentalslider", (el) => {
    const mode = el.dataset.sliderMode === "stakeholder" ? "stakeholder" : "environment";
    const isEmployeeSlider = mode === "stakeholder" && el.classList.contains("employee-swiper");
    const root =
      mode === "stakeholder"
        ? el.closest(".stakeholder-slider-wrap")
        : el.closest(".environment-section");
    const pickVisibleEl = (selector) => {
      const els = Array.from(root?.querySelectorAll(selector) ?? []);
      return els.find((node) => node.offsetParent !== null) ?? els[0] ?? null;
    };
    const paginationEl = pickVisibleEl(".agi-pagination");
    const prevBtn = pickVisibleEl(".agi-button-prev");
    const nextBtn = pickVisibleEl(".agi-button-next");
    const activeImageEl = root?.querySelector(".stakeholder-active-image");
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    const playEnvironmentalIntro = (swiper) => {
      if (mode !== "environment" || reducedMotion) return;
      if (!swiper?.slides?.length) return;
      if (el.dataset.envIntroPlayed === "1") return;
      el.dataset.envIntroPlayed = "1";

      const cards = swiper.slides.map((slide) => slide.firstElementChild || slide);
      if (window.gsap) {
        window.gsap.set(cards, { y: 18, autoAlpha: 0, scale: 0.985 });
        window.gsap.to(cards, {
          y: 0,
          autoAlpha: 1,
          scale: 1,
          duration: 0.65,
          stagger: 0.08,
          ease: "power2.out",
          clearProps: "opacity,visibility,transform",
        });
      } else {
        cards.forEach((card, index) => {
          card.animate(
            [
              { opacity: 0, transform: "translateY(18px) scale(0.985)" },
              { opacity: 1, transform: "translateY(0) scale(1)" },
            ],
            {
              duration: 650,
              delay: index * 80,
              easing: "cubic-bezier(0.22, 1, 0.36, 1)",
              fill: "both",
            },
          );
        });
      }
    };

    const initEnvironmentalIntroOnScroll = (swiper) => {
      if (mode !== "environment" || reducedMotion) return;
      if (!swiper?.slides?.length) return;
      if (el.dataset.envIntroObserved === "1") return;
      el.dataset.envIntroObserved = "1";

      const triggerEl = root || el;
      const rect = triggerEl.getBoundingClientRect();
      const inViewNow = rect.top < (window.innerHeight * 0.85) && rect.bottom > (window.innerHeight * 0.15);
      if (inViewNow) {
        playEnvironmentalIntro(swiper);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            playEnvironmentalIntro(swiper);
            observer.disconnect();
          });
        },
        { threshold: 0.25, rootMargin: "0px 0px -10% 0px" },
      );
      observer.observe(triggerEl);
    };

    const updateUi = (swiper) => {
      if (mode === "stakeholder") {
        const activeSlide =
          swiper?.slides?.[swiper.activeIndex] ??
          swiper?.slides?.[swiper.realIndex] ??
          null;
        const nextImage =
          activeSlide?.dataset?.slideImage ||
          activeSlide?.querySelector?.("[data-slide-image]")?.dataset?.slideImage ||
          "";
        if (activeImageEl) {
          if (nextImage) {
            if (activeImageEl.getAttribute("src") !== nextImage) {
              activeImageEl.setAttribute("src", nextImage);
            }
            activeImageEl.classList.remove("opacity-0");
          } else {
            activeImageEl.classList.add("opacity-0");
          }
        }

        const slideCount = swiper.slides.length;
        setCustomPagination({
          swiper,
          paginationEl,
          bulletsCount: slideCount,
          getSlideIndexByBullet: (index) => index,
          getActiveBulletIndex: () => swiper.realIndex,
          signature: `stakeholder:${slideCount}`,
          labelPrefix: "Go to slide",
        });
        setNavState(swiper, prevBtn, nextBtn);
      } else {
        const controls = Array.from(root?.querySelectorAll(".environmental-controls") ?? []);
        const showSliderUi = swiper.slides.length > 1 && !swiper.isLocked;
        root?.classList.toggle("environment-no-slider-ui", !showSliderUi);
        controls.forEach((control) => {
          control.classList.toggle("hidden", !showSliderUi);
        });

        setCustomPagination({
          swiper,
          paginationEl,
          bulletsCount: showSliderUi ? 2 : 0,
          getSlideIndexByBullet: (index) => (index === 0 ? 0 : swiper.slides.length - 1),
          getActiveBulletIndex: () => (swiper.progress >= 0.5 ? 1 : 0),
          signature: "environment:2step",
        });
        setNavState(swiper, prevBtn, nextBtn);
      }
    };

    const swiperOptions =
      mode === "stakeholder"
        ? {
          slidesPerView: 1,
          speed: isEmployeeSlider ? 560 : 700,
          autoHeight: true,
          watchOverflow: true,
          roundLengths: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          on: {
            init(swiper) {
              updateUi(swiper);
            },
            slideChange(swiper) {
              updateUi(swiper);
            },
            resize(swiper) {
              updateUi(swiper);
            },
          },
        }
        : {
          slidesPerView: "auto",
          spaceBetween: 24,
          speed: 560,
          grabCursor: true,
          watchOverflow: true,
          threshold: 8,
          longSwipesRatio: 0.2,
          resistanceRatio: 0.8,
          roundLengths: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          on: {
            init(swiper) {
              updateUi(swiper);
              initEnvironmentalIntroOnScroll(swiper);
            },
            slideChange(swiper) {
              updateUi(swiper);
            },
            resize(swiper) {
              updateUi(swiper);
            },
          },
          breakpoints: {
            768: {
              spaceBetween: 20,
            },
            1280: {
              spaceBetween: 24,
            },
          },
        };

    new Swiper(el, swiperOptions);
  });
}
